module.exports = __webpack_public_path__ + "static/media/29DUNON5.2c3a8af8.jpg";